import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useData } from '../../contexts/DataContext';

const { FiPlus, FiTrash2, FiTag, FiCheck } = FiIcons;

const CustomFieldSettings = () => {
  const { customFields, addCustomField, deleteCustomField } = useData();
  const [loading, setLoading] = useState(false);
  const [newField, setNewField] = useState({
    label: '',
    field_type: 'text',
    is_required: false
  });

  const handleAddField = async (e) => {
    e.preventDefault();
    if (!newField.label) return;
    
    setLoading(true);
    await addCustomField(newField);
    setNewField({ label: '', field_type: 'text', is_required: false });
    setLoading(false);
  };

  return (
    <div className="space-y-10">
      <div>
        <h2 className="text-2xl font-black text-slate-900 tracking-tighter mb-2 text-3xl">Custom Contact Fields</h2>
        <p className="text-slate-400 font-medium">Define data points specific to your business needs.</p>
      </div>

      <form onSubmit={handleAddField} className="bg-slate-50 p-8 rounded-[2rem] border border-slate-100 flex flex-col md:flex-row gap-4 items-end">
        <div className="flex-1 space-y-2">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Field Label</label>
          <input 
            className="w-full p-4 bg-white rounded-2xl border border-slate-100 outline-none font-bold" 
            placeholder="e.g. Industry, Birthday, Lead Score"
            value={newField.label}
            onChange={e => setNewField({...newField, label: e.target.value})}
          />
        </div>
        <div className="w-full md:w-48 space-y-2">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Type</label>
          <select 
            className="w-full p-4 bg-white rounded-2xl border border-slate-100 outline-none font-bold appearance-none"
            value={newField.field_type}
            onChange={e => setNewField({...newField, field_type: e.target.value})}
          >
            <option value="text">Text</option>
            <option value="number">Number</option>
            <option value="date">Date</option>
            <option value="select">Select</option>
          </select>
        </div>
        <button 
          type="submit"
          disabled={loading}
          className="bg-blue-600 text-white px-8 py-4 rounded-2xl font-black shadow-xl shadow-blue-100 hover:bg-blue-700 transition-all flex items-center gap-2"
        >
          <SafeIcon icon={FiPlus} /> Add Field
        </button>
      </form>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <AnimatePresence>
          {customFields.map(field => (
            <motion.div 
              key={field.id}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="bg-white p-6 rounded-3xl border border-slate-100 flex items-center justify-between hover:shadow-lg transition-all"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
                  <SafeIcon icon={FiTag} />
                </div>
                <div>
                  <p className="font-black text-slate-900 tracking-tight">{field.label}</p>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{field.field_type}</p>
                </div>
              </div>
              <button 
                onClick={() => deleteCustomField(field.id)}
                className="p-2 text-slate-300 hover:text-red-500 transition-colors"
              >
                <SafeIcon icon={FiTrash2} />
              </button>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default CustomFieldSettings;